var _rect, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 680,
    height: 920,
    viewBox: "0 0 680 920",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 680,
    height: 920,
    rx: 30,
    fill: "#229B61"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 460,
    r: 100,
    fill: "#F3F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323.192 498.472C320.933 498.472 318.674 497.613 316.951 495.89L293.42 472.359C289.973 468.912 289.973 463.329 293.42 459.882C296.867 456.434 302.45 456.434 305.897 459.882L323.186 477.171L375.772 424.585C379.219 421.138 384.802 421.138 388.249 424.585C391.696 428.033 391.696 433.615 388.249 437.063L329.422 495.89C327.71 497.613 325.451 498.472 323.192 498.472Z",
    fill: "#229B61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.c6f036aa855c285fae0aeea72d1a5966.svg";
export { ForwardRef as ReactComponent };